module.exports = __webpack_public_path__ + "./fonts/Simple-Line-Icons.0cb0b9c589c0624c9c78dd3d83e946f6.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module chunks = 14